import {
  createFrontendModule,
  // createExtension,
  // coreExtensionData,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { PlusCircle } from 'lucide-react';
// import { compatWrapper } from '@backstage/core-compat-api';
// import { CustomCreatePage } from '../components/create/CustomCreatePage';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';

// Create a custom scaffolder navigation item with better icon
// IMPORTANT: No 'name' property to ensure ID matches the original 'nav-item:scaffolder'
const customScaffolderNavItem = NavItemBlueprint.make({
  params: {
    title: 'Create',
    icon: PlusCircle as IconComponent,
    routeRef: scaffolderPlugin.routes.root,
  },
});

// Apply override to replace the factory function
const customScaffolderNavExtension = customScaffolderNavItem.override({
  factory: (originalFactory, context) => {
    return originalFactory(context);
  },
});

// const customScaffolderPage = createExtension({
//   kind: 'page',
//   attachTo: { id: 'app/routes', input: 'routes' },
//   output: [
//     coreExtensionData.routePath,
//     coreExtensionData.reactElement,
//     coreExtensionData.routeRef,
//   ],
//   factory: () => [
//     coreExtensionData.routePath('/create'),
//     coreExtensionData.reactElement(compatWrapper(<CustomCreatePage />)),
//     coreExtensionData.routeRef(scaffolderPlugin.routes.root),
//   ],
// });

// Create a module that contains our custom scaffolder configurations
// Using 'scaffolder' as pluginId since we're overriding scaffolder plugin
export const customScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    customScaffolderNavExtension, // Add the custom nav item with override
    // Add more scaffolder customizations here later
  ],
});